import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { ButtonSize } from 'constants/button';
import { SignLinkButton } from 'ui-components/common/SignLinkButton';

interface UserLoginMenuProps {
  onBlur?: () => void;
}

export const UserLoginMenu = ({ onBlur }: UserLoginMenuProps) => (
  <StyledLoginMenu onClick={onBlur}>
    <StyledLoginMenuWrapper>
      <p>더 많은 기능을 사용하려면,</p>
      <p>디리토에 로그인 또는 가입해보세요.</p>
      <StyledSignLinkButton
        label="로그인 또는 회원가입"
        size={ButtonSize.Small}
        buttonTypography={Typography.XXXSmall}
      />
    </StyledLoginMenuWrapper>
    <StyledDivider />
  </StyledLoginMenu>
);

const StyledDivider = styled.div`
  height: 1px;
  background-color: ${Color.Gray200};
  flex: none;
  order: 1;
  flex-grow: 0;
`;

const StyledLoginMenu = styled.div`
  position: relative;
`;

const StyledLoginMenuWrapper = styled.div`
  padding: 16px;

  & > p {
    text-align: center;
    color: ${Color.Gray600};
    ${Typography.XXSmall};
  }
`;

const StyledSignLinkButton = styled(SignLinkButton)`
  margin-top: 16px;
  width: 100%;

  & > button {
    margin-top: 16px;
    width: 100%;
  }
`;
